"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
const teamMembers = [{
  id: 1,
  name: "Barbara Parchomiuk",
  role: "Pełnomocnik Kancelarii TRASTA",
  image: "https://ample-sailfish.10web.cloud/wp-content/uploads/2026/02/O79AE1.png?v=hys7z3342pg"
}, {
  id: 2,
  name: "Agnieszka Kmita",
  role: "Pełnomocnik Kancelarii TRASTA",
  image: "https://ample-sailfish.10web.cloud/wp-content/uploads/2026/02/ODSZKODOWANIA-SLUPSK-2.png?v=ujrz8qgja3p"
}, {
  id: 3,
  name: "Dariusz Protas",
  role: "Pełnomocnik Kancelarii TRASTA",
  image: "https://ample-sailfish.10web.cloud/wp-content/uploads/2026/02/ODSZKODOWANIA-SLUPSK-3.png?v=e7u4uihzwhc"
}];
export default function OurTeamOverview() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="nasz-zespół-przegląd" ref={sectionRef} className="bg-background py-16 md:py-24 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className={`text-center mb-12 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-4xl md:text-5xl font-display font-semibold tracking-tight text-foreground mb-4">
            Nasz zespół
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Poznaj profesjonalistów, którzy pomogą Ci w dochodzeniu sprawiedliwości
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member, i) => <Card key={member.id} data-index={i} className={`group relative bg-white border border-border hover:border-primary hover:shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-2 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
          transitionDelay: isVisible ? `${i * 100}ms` : "0ms"
        }}>
              <CardContent className="p-0">
                <div className="relative overflow-hidden rounded-t-xl">
                  <SafeHydrate><Avatar className="w-full h-80 rounded-none">
                    <AvatarImage src={member.image} alt={member.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:scale-105" />
                    <AvatarFallback className="w-full h-full rounded-none bg-muted text-4xl font-display">
                      {member.name.split(" ").map(n => n[0]).join("")}
                    </AvatarFallback>
                  </Avatar></SafeHydrate>
                </div>

                <div className="p-6 text-center">
                  <h3 className="text-2xl font-display font-semibold text-foreground mb-2">
                    {member.name}
                  </h3>
                  <p className="text-base text-muted-foreground font-sans">
                    {member.role}
                  </p>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}